<script lang="ts">
  import SectionFractionDsn from '@/generated/sections/SectionFractionDsn.vue';
  import Etablissement from '@/generated/classes/Etablissement';
  import { FractionDsnGenres, FractionDsnTypes } from '@/generated/classes/FractionDsn';
  import { defineComponent } from "vue";
  import { GenSection, RessourceGenSection } from "@/generated/ressources/generatedRessources.ts";
  import { AppSections, RessourceAppSection } from "@/ressources/globalRessources.ts";
  import { storeEtablissement } from '@/generated/stores';
  import Societe from '@/generated/classes/Societe';
  import { FieldStatus } from '@/framework/base/components/FieldInfo';
  import Button from '@/framework/base/classes/Button';

  export default defineComponent({
    extends: SectionFractionDsn,
    name: 'SectionFractionDsnExtend',
    components: {},
    data() {
      const buttons: Button[] = [];

      return {
        buttons
      };
    },
    computed: {
      ressource() {
        if (this.fractionDsn.id < 0) {
          const etablissement = storeEtablissement.getEtablissement(this.fractionDsn.etablissementId);
          this.fractionDsn.fraction = etablissement.fractionDsn.filter(a => a.genre != FractionDsnGenres.TESE_CEA).length + 1;
          return RessourceAppSection(AppSections.NEW_GESTIONNAIRE);
        } else {
          return RessourceGenSection(GenSection.FRACTION_DSN);
        }
      },
      extraButtons(): Button[] {
        if (this.buttons.length == 0 && this.fractionDsn.genre != FractionDsnGenres.AGETA && this.fractionDsn.id != 99 && this.fractionDsn.id > 0) {
          const remove = new Button();
          remove.label = 'Supprimer';
          remove.show = true;
          remove.disabled = false;
          remove.outlined = true;
          remove.loading = false;
          remove.callback = () => this.removeFraction();
          this.buttons.push(remove);
        }
        return this.buttons;
      }
    },
    methods: {
      readOnly(value: string): boolean {
        let res = false;
        if (this.readOnlyMap.size == 0) {
          const etablissement = storeEtablissement.getEtablissement(this.fractionDsn.etablissementId);
          const wizard = etablissement.fractionDsn.find(a => a.genre == FractionDsnGenres.AGETA) == undefined;
          const ro = this.fractionDsn.genre == FractionDsnGenres.AGETA || this.fractionDsn.genre == FractionDsnGenres.TESE_CEA;
          this.readOnlyMap.set("GENRE", this.fractionDsn.genre == FractionDsnGenres.AGETA || wizard);
          this.readOnlyMap.set("TYPE", ro);
          this.readOnlyMap.set("FRACTION", this.fractionDsn.genre == FractionDsnGenres.TESE_CEA);
          this.readOnlyMap.set("ENTITE", ro);
          this.readOnlyMap.set("NOM", ro);
          this.readOnlyMap.set("PRENOM", ro);
          this.readOnlyMap.set("MAIL", ro);
          this.readOnlyMap.set("NUMERO", ro);
        }
        const readOnly = this.readOnlyMap.get(value);
        if (readOnly != undefined) {
          res = readOnly;
        }
        return res;
      },
      isDisplayed(value: string): boolean {
        let res = true;
        if (this.displayMap.size == 0) {
          const requiredAttributs = this.getRequiredAttributs();
          this.displayMap.set("GENRE", true);
          this.displayMap.set("ENTITE", this.fractionDsn.genre != FractionDsnGenres.NONE && this.fractionDsn.genre != FractionDsnGenres.CLIENT);
          this.displayMap.set("FRACTION", this.fractionDsn.id != 99 && (this.fractionDsn.genre != FractionDsnGenres.NONE || this.fractionDsn.genre == FractionDsnGenres.TESE_CEA));
          this.displayMap.set("TYPE", true);
          this.displayMap.set("NOM", this.fractionDsn.genre != FractionDsnGenres.NONE);
          this.displayMap.set("PRENOM", this.fractionDsn.genre != FractionDsnGenres.NONE);
          this.displayMap.set("MAIL", this.fractionDsn.genre != FractionDsnGenres.NONE);
          this.displayMap.set("NUMERO", this.fractionDsn.genre != FractionDsnGenres.NONE);
        }
        const display = this.displayMap.get(value);
        if (display != undefined) {
          res = display;
        }
        return res;
      },
      isRequired(value: string): boolean {
        let res = true;
        const requiredAttributs = this.getRequiredAttributs();
        if (this.requiredMap.size == 0) {
          this.requiredMap.set("GENRE", true);
          this.requiredMap.set("ENTITE", false);
          this.requiredMap.set("TYPE", true);
          this.requiredMap.set("FRACTION", false);
          this.requiredMap.set("NOM", false);
          this.requiredMap.set("PRENOM", false);
          this.requiredMap.set("MAIL", false);
          this.requiredMap.set("NUMERO", false);
        }
        const required = this.requiredMap.get(value);
        if (required != undefined) {
          res = required;
        }
        return res;
      },
      fieldUpdated(field: string, value: unknown): void {
        if (field == "GENRE") {
          if (value == FractionDsnGenres.TESE_CEA) {
            this.type = FractionDsnTypes.PERMANENT;
            this.nom = "URSSAF";
            const etablissement = storeEtablissement.getEtablissement(this.fractionDsn.etablissementId);
            Societe.get(etablissement.societeId).then((res) => {
              if (res.association) {
                this.entite = "Service CEA";
                this.numero = "08 06 80 15 01";
                this.fraction = 6;
              } else {
                this.entite = "Service TESE";
                this.numero = "08 06 80 38 73";
                this.fraction = 6;
              }
            });
          }
          this.readOnlyMap.clear();
          this.requiredMap.clear();
          this.displayMap.clear();
        }
      },
      removeFraction(): void {
        Etablissement.deleteFractionDsn(this.fractionDsn).then(() => {
          this.$emit('closeDialog');
        });
      },
      sectionSave(): void {
        if (this.checkFields()) {
          Etablissement.saveFractionDsn(this.fractionDsn).then(() => {
            this.$emit('closeDialog');
          });
        }
      },
    },
  });
</script>